// Importa al CRM la libreta de contactos de una persona (vCard u Outlook CSV ya leidos con lib/libreta).
import { normalize } from '../lib/format';
import type { ContactoLibreta } from '../lib/libreta';
import { crearEmpresa, crearPersona, todasLasEmpresas } from './crm';
import { f, list } from './rest';

const esperar = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function correosExistentes(correos: string[]) {
  const out = new Set<string>();
  const unicos = [...new Set(correos.filter(Boolean))];
  for (let i = 0; i < unicos.length; i += 50) {
    const page = await list<{ emails?: { primaryEmail?: string } }>('people', { filter: f.in('emails.primaryEmail', unicos.slice(i, i + 50)), limit: 200, depth: 0 });
    for (const p of page.items) if (p.emails?.primaryEmail) out.add(p.emails.primaryEmail.toLowerCase());
  }
  return out;
}

export type Avance = { hechos: number; total: number; empresasNuevas: number; fallidos: string[] };

// Crea las empresas que falten (por nombre) y luego las personas, una a una para no saturar el servidor.
export async function importarContactos(nuevos: ContactoLibreta[], onAvance: (a: Avance) => void) {
  const avance: Avance = { hechos: 0, total: nuevos.length, empresasNuevas: 0, fallidos: [] };
  const empresas = new Map((await todasLasEmpresas()).map((e) => [normalize(e.nombre), e.id]));
  for (const c of nuevos) {
    let empresaId: string | null = null;
    const clave = normalize(c.empresa);
    if (clave) {
      empresaId = empresas.get(clave) ?? null;
      if (!empresaId) {
        try {
          empresaId = (await crearEmpresa({ nombre: c.empresa, dominio: '', ciudad: '' })).id;
          empresas.set(clave, empresaId);
          avance.empresasNuevas += 1;
        } catch {
          empresaId = null;
        }
      }
    }
    const datos = { nombre: c.nombre, apellido: c.apellido, cargo: c.cargo, email: c.email, telefono: c.telefono, empresaId };
    try {
      await crearPersona(datos);
    } catch {
      // Un telefono que el servidor no acepta no debe impedir traer el contacto.
      try {
        if (!c.telefono) throw new Error('sin telefono');
        await crearPersona({ ...datos, telefono: '' });
      } catch {
        avance.fallidos.push(c.email || `${c.nombre} ${c.apellido}`.trim());
      }
    }
    avance.hechos += 1;
    onAvance({ ...avance });
    await esperar(120);
  }
  return avance;
}
